import { Injectable } from '@angular/core';
import { IDialogOptions } from '@tylertech/forge-angular';
import moment from 'moment';
import { EMAIL_ADDRESS_REGEX } from 'app/shared/constants/regex.constants';

@Injectable({
    providedIn: 'root'
})
export class Constants {

    public serviceUrl: any;
    public tidServiceUrl: any;
    public meetingConfig: any;
    public popupConfig: any;
    public messages: any;
    public calendarDateFormat: any;
    public sessionStorageKey: any;
    public responeKey: any;
    public agendaItemStatus: any;
    public minutesStatus: any;
    public agendaItemWorflowDetails: any;
    public minutesWorflowDetails: any;
    public agendaItemStatusList: Array<any>;
    public leftPanelList: Array<any>;
    public agendaItemFilterLists: any;
    public thumbnailUrl = 'https://i.ytimg.com/vi/videoId/mqdefault.jpg';
    public searchResultFields = {
        "meetingName":{
            label:"Meeting Name",
            property:"meetingName",
        },
        "meetingDate":{
            label:"Date",
            property:"date"
        },
        "meetingType":{
            label:"Meeting Type",
            property:"meetingType"
        },
        "description":{
            label:"Description",
            property:"description"
        },
        "documentStatus":{
            label:"Document Status",
            property:"documentStatus"
        }
    }
    public documentStatusDisplayName = {
        agenda:"Agenda Posted",
        minutes:"Minutes Posted",
        video:"Video Posted"
        
    }
    public attachmentOptions = {
        packetAgenda:{
            label:"View Agenda Packet",
            value:"packet"
        },
        summaryAgenda:{
            label:"View Agenda Summary",
            value:"summary"
        },
        packetMinutes:{
            label:"View Minutes Packet",
            value:"packet"
        },
        summaryMinutes:{
            label:"View Minutes Summary",
            value:"summary"
        }
    }

    public shareOptions = {
        copyMinutes:{
            label:"Copy Minutes Link",
            value:"copyMinutes"
        },
        copyAgenda:{
            label:"Copy Agenda Link",
            value:"copyAgenda",
        },
        publicSummary:{
            label:'Public Summary',
            value:'publicSummary'
        },
        publicPackets:{
            label:'Public Packets',
            value:'publicPackets'
        }

    }
    public readonly youtubeStatus = {
        public: 'public',
        private: 'private',
        deleted: 'delete',
        unlisted: 'unlisted',
        duplicate: 'duplicate',
        rejected: 'rejected',
        live: 'live'
    };
    public noSearchResultFoundImg = 'https://cdn.forge.tylertech.com/v1/images/spot-hero/no-search-results-spot-hero.svg';
    pageSizeOptions = [20, 40, 60, 80, 100];
    subscriptionOptions = {
        notifyFor: {
            thisMeeting: false,
            allMeetings: true
        }
    };
    public calendarViews = [ 
        { id: 'list', label: 'List' },
        { id: 'timeGridDay', label: 'Day' },
        { id: 'timeGridWeek', label: 'Week' },
        { id: 'dayGridMonth', label: 'Month' }
    ];
    emailRegex = EMAIL_ADDRESS_REGEX;
    findSearchedWordRegex = /[-\/\\^$*+?.()|[\]{}]/ig;
    replaceSearchedWordRegex ="\\$&";
    regexFlag = "ig";
    selectAllOption = { id: -1, title: "Select All" };
    drawerTypes = {
        modal: 'modal',
        dismissable: 'dismissable'
    };
    forgeDialog = {
        dialogClass: 'dialog-class',
        dialogSubscriptionClass: 'dialog-subscription-class',
        btnData: {
            yesBtnText: 'YES',
            cancelBtnText: 'CANCEL',
            deleteBtnText: 'DELETE',
            okBtnText: 'OK',
            noBtnText: 'NO',
            saveBtnText: 'SAVE'
        },
        returnData: {
            okText: 'ok',
            cancelText: 'cancel',
            optionalButtonText: 'optionalButton',
        }
    };
    paginatorTypes = {
        lastPage: 'last-page',
        nextPage: 'next-page',
        previousPage: 'previous-page'
    };
    constructor() {

        this.serviceUrl = {
            meeting: {
                create: 'meeting/saveOrUpdateMeeting',
                lookup: 'meetingType/getMeetingTypes',
                getMeetingByDateRange: 'meetingInformation/getMeetingInformationByDate',
                delete: 'meeting/deleteMeetingRecurring',
                getMeeting: 'meetingInformation/getMeeting',
                saveDragAndDropMeeting: 'meeting/saveDragAndDropMeeting',
                agendaMergedPdf: 'meetingInformation/getAgendaMergePDF',
                printMinutes: 'meetingInformation/printMinutesMeetingPacket/',
            },
            meetingType: {
                create: 'meetingType/saveMeetingType',
                getTemplates: 'agendaTemplate/getAgendaTemplate',
                getSectionHeaders: 'lookup/meetingType/getSectionHeaders',
                getAttendees: 'lookup/meetingType/getAttendees',
                meetingTypeColor: 'lookup/meetingType/getMeetingTypeColor',
                getMeetingTypeById: 'lookup/getMeetingTypeById',
                deleteMeetingType: '/meetingType/deleteMeetingType',

            },
            minutes: {
                getMinutes: 'minutesMeeting/getMinutesMeeting/',
                getMeetingsWithNoMinutes: 'meeting/getMeetingsWithNoMinutesMeeting',
                printMinutes: 'minutesMeeting/printMinutesMeetingPacket/'
            },
            shareableLink: {
                agendaLink: 'meetingInformation/Agenda/',
                minutesLink: 'meetingInformation/Minutes/'
            },
            searchResult: {
                search: 'meetingCalendarSearch/search'
            },
            subscription: {
                saveSubscriberInfo: 'subscriber/saveSubscriberInfo'
            }
        };

        this.sessionStorageKey = {
            meetingTypeId: 'meetingTypeId',
            agendaTemplateId: 'agendaTemplateId',
            meetingTypeModel: 'meetingTypeModel',
            agendaTemplateNavigation: 'agendaTemplateNavigation',
            tylerUserList: 'TylerUserList',
            agendaTemplateNavigationUrl: 'agendaTemplateNavigationUrl',
            meetingTypeNavigationUrl: 'meetingTypeNavigationUrl'
        };

        this.responeKey = {
            agendaTemplateId: 'agendaTemplateId'
        };

        this.agendaItemStatus = {
            draft: 0,
            pending: 1,
            assigned: 2,
            rejected: 3,
            unassigned: 4,
            posted: 5,
            tabled: 6
        };

        this.minutesStatus = {
            draft: 0,
            pending: 1,
            assigned: 2,
            rejected: 3,
            unassigned: 4,
            posted: 5,
            tabled: 6
        };


        this.agendaItemStatusList = [
            {
                name: 'Rejected',
                status: this.agendaItemStatus.rejected,
                checked: false
            },
            {
                name: 'Draft',
                status: this.agendaItemStatus.draft,
                checked: false
            },
            {
                name: 'Pending',
                status: this.agendaItemStatus.pending,
                checked: false
            },
            {
                name: 'Unassigned',
                status: this.agendaItemStatus.unassigned,
                checked: true
            }
        ];

        this.leftPanelList = [
            {
                name: 'Minutes',
                status: 0,
                checked: false,
            },
            {
                name: 'Agenda',
                status: 1,
                checked: false
            },
            {
                name: 'Agenda Item',
                status: 2,
                checked: false
            }
        ];

        this.agendaItemFilterLists = [
            {
                name: 'Minutes',
                status: 3,
                checked: true,
            },
            {
                name: 'Agenda',
                status: 1,
                checked: true
            },
            {
                name: 'Agenda Item',
                status: 0,
                checked: true
            }
        ];

        this.agendaItemWorflowDetails = {
            noApproval: 0,
            limitedApprovers: 1,
            allApprovers: 2,
            allSeqApprovers: 3
        };

        this.minutesWorflowDetails = {
            noApproval: 0,
            limitedApprovers: 1,
            allApprovers: 2,
            allSeqApprovers: 3
        };

        this.messages = {
            success: {
                meetingCreated: 'Meeting saved successfully',
                meetingDeleted: 'Meeting deleted successfully',
                meetingDurationUpdated: 'Meeting duration has been updated',
                meetingTypeCreated: 'Meeting Type saved successfully',
                agendaItemCreated: 'Agenda Item saved successfully',
                deletedMeetingType: 'Meeting Type deleted successfully',
                agendaItemDeleted: 'Agenda Item deleted successfully',
                agendaTemplateCreated: 'Agenda Template saved succssfully',
                agendaItemWorkflow: 'Agenda Item is',
                agendaCreated: 'Agenda created successfully',
                agendaWorkflow: 'Agenda is',
                agendaUpdated: 'Agenda saved successfully',
                agendaDeleted: 'Agenda deleted successfully.',
                commentsUpdated: 'Comment saved successfully',
                minutesMeetingSaved: 'Minutes saved successfully.',
                agendaPosted: 'Agenda posted successfully',
                agendaUnposted: 'Agenda unposted successfully',
                minutesMeetingDeleted: 'Minutes deleted successfully.',
                minutesWorkflow: 'Minutes is',
                minutesPosted: 'Minutes posted successfully',
                minutesUnposted: 'Minutes unposted successfully',
                linkCopiedToClipboard: 'Link copied to clipboard'
            },
            error: {
                notFound: '404 NOT FOUND',
                internalServerError: '500 INTERNAL SERVER ERROR',
                unsafeHtml: 'Unsafe html content',
                voteCountExceed: 'Total vote count is more than number of voting members',
                fetchEmailConfig: 'Issue while fetching system configuration',
                updateEamilConfig: 'Issue while update the configuration value',
                errorWhileMergePDF: 'An error to get the merge pdf',
                accessDeniedForTCMAttachment: 'You don\'t have access rights of TCM Attachment!',
                motionErrorMessage: 'Motion and Second are already entered',
                accessDeniedForAddUser: 'You don\'t have access rights of Add user in TID!',
                popupBlocked: 'It looks like you have pop-ups blocked in your browser settings. To view the meeting documents, please enable pop-ups.',
                unauthorizedAccess: 'Unauthorized: Sorry, you don\'t have access to this.'
            }
        };

        this.meetingConfig = {
            startTime: '08:00',
            endTime: '17:00',
            startLoopTime: 8,
            endLoopTime: 18,
            timeDifferenceInMinutes: 30,
            initialTimeFormat: 'HH:mm:ss',
            startDate: moment().toDate(),
            endDate: moment().toDate(),
            maxDays: 547,
            maxWeeks: 80,
            maxMonths: 60,
            maxYears: 5,
            nextMonth: moment().add(1, 'months'),
            previousMonth: moment().subtract(1, 'months'),
            meetingType: {
                noRepeat: 'NoRepeat',
                daily: 'Daily',
                weekly: 'Weekly',
                monthly: 'Monthly',
                yearly: 'Yearly',
                weeklyBusiness: 'WeeklyBusiness'
            }
        };
        this.popupConfig = {
            height: (screen.height - 150) + 'px',
            width: (screen.width / 2) + 'px'
        };
        this.calendarDateFormat = {
            parse: {
                dateInput: 'dddd M/D/YY',
            },
            display: {
                dateInput: 'dddd M/D/YY',
                monthYearLabel: 'MMM YYYY',
                dateA11yLabel: 'LL',
                monthYearA11yLabel: 'MMMM YYYY',
            },
        };
    }
    setDialogOptions(persistent: boolean, dialogClass = ''): IDialogOptions {
        return {
            dialogClass,
            persistent
        };
    }
}
